import classNames from 'classnames';

import styles from './index.module.css';
import React from 'react';
import { RedEnvelopeDiscount } from '@meitu/subscribe-core';
import { RedEnvelopeType } from '@/constants/subscription';

/**
 * 优惠卷组件属性
 */
export interface CouponDiscountProps {
  /**
   * 红包优惠信息
   */
  promotion: RedEnvelopeDiscount;

  /**
   * 样式
   */
  style?: Record<string, string>;

  /**
   * 单张优惠券样式
   */
  isSingleStyle?: boolean;
}

/**
 * 优惠信息
 *
 * 本期只有商品原价折
 */
export const CouponDiscount: React.FC<CouponDiscountProps> = (props) => {
  const { promotion, isSingleStyle = false, style } = props;

  if (!promotion) return null;

  /**
   * 渲染优惠文案，如：￥30，3天
   */
  const renderPromotionLabel = () => {
    /**
     * 免费试用
     */
    if ((promotion.envelopeType as number) === RedEnvelopeType.FreeTrial) {
      return (
        <div className={styles.money}>
          <span className={styles.amount}>{Number(promotion.promotionNum) / 100}</span>
          <span className={styles.amount}>{promotion.promotionUnit}</span>
        </div>
      );
    }

    return (
      <div className={styles.money}>
        <span className={styles.unit}>{promotion.promotionUnit}</span>
        <span className={styles.amount}>{Number(promotion.promotionNum) / 100}</span>
      </div>
    );
  };

  /**
   * 渲染优惠标签
   */
  const renderPromotionTag = () => {
    if (
      [RedEnvelopeType.FreeTrial, RedEnvelopeType.LowPriceTrial].includes(
        promotion.envelopeType as number
      )
    )
      return;

    return <div className={styles.tag}>{promotion.promotionSecondaryShowText}</div>;
  };

  /**
   * 单个红包时的优惠券样式
   */
  if (isSingleStyle) {
    return (
      <div
        className={classNames(styles.couponDiscount, isSingleStyle && styles.couponDiscountSingle)}
        style={style}
      >
        <div className={styles.header}>
          <div className={styles.name}>{promotion.productName}</div>
          {renderPromotionTag()}
        </div>
        {renderPromotionLabel()}
        <div className={styles.validity}>{promotion.productSecondaryName}</div>
      </div>
    );
  }

  return (
    <div className={styles.couponDiscount} style={style}>
      <div className={styles.left}>
        {renderPromotionLabel()}
        {renderPromotionTag()}
      </div>
      <div className={styles.right}>
        <div className={styles.name}>{promotion.productName}</div>
        <div className={styles.validity}>{promotion.productSecondaryName}</div>
      </div>
    </div>
  );
};
